import { render, staticRenderFns } from "./StreamsTable.vue?vue&type=template&id=03544bb2"
import script from "./StreamsTable.vue?vue&type=script&lang=js"
export * from "./StreamsTable.vue?vue&type=script&lang=js"
import style0 from "./StreamsTable.vue?vue&type=style&index=0&id=03544bb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports